import React from 'react';

import { activeNetworkSelector } from 'redux/selectors';
import { useSelector } from 'react-redux';
import { MainLayoutHeader } from '../../components/atoms/mainLayoutHeader';
import MainLayout from '../../components/layout/Main';
import { ConnectHome } from './connectHome';
import { NoConnectHome } from './noConnectHome';

const Home = () => {
  const { connect, name } = useSelector(activeNetworkSelector);

  return (
    <MainLayout>
      <MainLayoutHeader title={connect?.hasAccess ? 'Home' : 'Discover GetroConnect'} />

      {connect?.hasAccess && <ConnectHome />}
      {!connect?.hasAccess && <NoConnectHome networkName={name} />}
    </MainLayout>
  );
};

export default Home;
